import { render, staticRenderFns } from "./ListaApoioUnidade.vue?vue&type=template&id=1cc7202c&scoped=true"
import script from "./ListaApoioUnidade.vue?vue&type=script&lang=js"
export * from "./ListaApoioUnidade.vue?vue&type=script&lang=js"
import style0 from "./ListaApoioUnidade.vue?vue&type=style&index=0&id=1cc7202c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc7202c",
  null
  
)

export default component.exports